import { createSlice } from "@reduxjs/toolkit";
import { apiCallStarted } from "../middleware/api";

const slice = createSlice({
    name: "contactUsMessages",
    initialState: {
        list: [],
        contactUsMessageDetails: {},
        loading: false,
        lastFetch: null,
        rowCount: 0,
        pageSize: 0,
        page: 0,
        loadingMessage: false,
        deletingMessage: false
    },
    reducers: {
        contactUsMessagesRequested: (contactUsMessages, action) => {
            contactUsMessages.loading = true;
        },
        contactUsMessagesRequestSucceeded: (contactUsMessages, action) => {
            const { docs, totalDocs, limit, page } = action.payload.body;
            if (page && page > contactUsMessages.page) {
                contactUsMessages.list = [...contactUsMessages.list, ...docs];
                contactUsMessages.page = page;
                contactUsMessages.rowCount = totalDocs;
                contactUsMessages.pageSize = limit;
            }
            contactUsMessages.loading = false;
            contactUsMessages.lastFetch = Date.now();
        },
        contactUsMessagesRequestFailed: (contactUsMessages, _) => {
            contactUsMessages.loading = false;
        },
        contactUsMessageDetailsRequested: (contactUsMessages, action) => {
            contactUsMessages.loadingMessage = true
        },
        contactUsMessageDetailsRequestSucceeded: (contactUsMessages, action) => {
            contactUsMessages.loadingMessage = false
            contactUsMessages.contactUsMessageDetails = action.payload.body;
        },
        contactUsMessageDetailsRequestFailed: (contactUsMessages, action) => {
            contactUsMessages.loadingMessage = false
        },
        contactUsMessageAdded: (contactUsMessages, action) => {
            contactUsMessages.list.push(action.payload);
        },
        contactUsMessageDeleteRequested: (contactUsMessages, action) => {
            contactUsMessages.deletingMessage = true
        },
        contactUsMessageDeleteSucceeded: (contactUsMessages, action) => {
            contactUsMessages.deletingMessage = false
            console.log(action.payload)
            const index = contactUsMessages.list.findIndex(
                (contactUsMessage) => contactUsMessage.id === action.payload.id
            );
            contactUsMessages.list.splice(index, 1);
        },
        contactUsMessageDeleteFailed: (contactUsMessages, action) => {
            contactUsMessages.deletingMessage = false
        },
        pageChanged: (contactUsMessages, action) => {
            const { page: targetPage } = action.payload;
            contactUsMessages.page = targetPage;
        },
        clearContactUsMessages: (contactUsMessages, action) => {
            contactUsMessages.list = [];
            contactUsMessages.page = 0;
            contactUsMessages.rowCount = 0;
            contactUsMessages.pageSize = 0;
            contactUsMessages.lastFetch = null;
            contactUsMessages.loading = false;
        },
        clearContactUsMessageDetails: (contactUsMessages, action) => {
            contactUsMessages.contactUsMessageDetails = {};
        }
    },
});

export const {
    contactUsMessagesRequested,
    contactUsMessagesRequestSucceeded,
    contactUsMessagesRequestFailed,
    contactUsMessageDetailsRequested,
    contactUsMessageDetailsRequestSucceeded,
    contactUsMessageDetailsRequestFailed,
    contactUsMessageAdded,
    contactUsMessageDeleteRequested,
    contactUsMessageDeleteSucceeded,
    contactUsMessageDeleteFailed,
    pageChanged,
    clearContactUsMessages,
    clearContactUsMessageDetails
} = slice.actions;

// Action Creators
const url = "/v1/admin-panel/contact-us";

export const loadContactUsMessages = page => (dispatch, getState) => {
    dispatch(
        apiCallStarted({
            url: `${url}?page=${page}`,
            onStart: contactUsMessagesRequested.type,
            onSuccess: contactUsMessagesRequestSucceeded.type,
            onError: contactUsMessagesRequestFailed.type,
        })
    );
};

export const loadContactUsMessageDetails = id => (dispatch, getState) => {
    dispatch(
        apiCallStarted({
            url: `${url}/${id}`,
            onStart: contactUsMessageDetailsRequested.type,
            onSuccess: contactUsMessageDetailsRequestSucceeded.type,
            onError: contactUsMessageDetailsRequestFailed.type,
        })
    );
};

export const deleteContactUsMessage = id => (dispatch, getState) => {
    dispatch(
        apiCallStarted({
            url: `${url}/${id}`,
            method: 'delete',
            onStart: contactUsMessageDeleteRequested.type,
            onSuccess: contactUsMessageDeleteSucceeded.type,
            onError: contactUsMessageDeleteFailed.type,
        })
    );
};

export default slice.reducer;
